export default {
	data(){
		return {
			tableGBoptions: { 
				options: { editar: 'Editar Orden'},
				modals: [
					{
					  modal: "Recibir",
					  icon: "check-circle",
					  title: "Recibir pedido"
					},
					{
						modal: "Entregar",
						icon: "inbox-fill",
						title: "Confirmar entrega al cliente"
					},
				]
			},

			tableGBSearch: ['datos_pacientes/name','garantia_orden/consecutivo'],
			
			tableGBItems: [
				{
					thead: { th: '# orden' },
					tbody: { td: ['garantia_orden/consecutivo'],}
				},
				{
					thead: { th: 'Paciente', sort: null, sortTable: 'datos_pacientes/name'},
					tbody: { td: ['datos_pacientes/name']}
				},
				{
					thead: { th: 'Telefonos', },
					tbody: { td: ['datos_pacientes/telefonos'],}
				},
				{
					thead: { th: 'Estado', sort: null, sortTable: 'garantia_orden/estado'},
					tbody: { td: ['garantia_orden/estado'],}
				},
				{
					thead: { th: 'L. Lente', },
					tbody: { td: ['datos_proveedores_lente/name'],}
				},
				{
					thead: { th: 'L. Montura', },
					tbody: { td: ['datos_proveedores_montura/name'],}
				},
				{
					thead: { th: 'Orden', },
					tbody: { td: ['garantia_orden/id_info_garantia'], link: '/api/pdf/garantia_orden_venta'}
				},
			]
		}
	},
}